// eslint-disable-next-line no-shadow
export var Department = /*#__PURE__*/function (Department) {
  Department["Default"] = "CX Customer Support";
  return Department;
}({});
export var ZENDESK_TAG_URL = {
  profileGeneralInfo: '/profile/general_info',
  profileEducationHistory: '/profile/education_history',
  profileTestScores: '/profile/test_scores',
  profileVisaAndStudyPermit: '/profile/visa_and_study_permit',
  profile: '/profile',
  profileEducationHistoryRp: '/students/:student_id/EducationHistoryPage',
  profileTestScoresRp: '/students/:student_id/TestScoresPage',
  profileBackgroundInformationRp: '/students/:student_id/BackgroundInformationPage',
  profileUploadDocumentsRp: '/students/:student_id/UploadProfileDocumentsPage',
  profileStudentsRp: '/students/:student_id',
  studentDashboard: '/students/:student_id/dashboard',
  students: '/students',
  applications: '/students/:student_id/applications',
  payments: '/students/:student_id/payments',
  myApplications: '/my_applications',
  partners: '/partners',
  partnerLandingPage: '/partners/:id/landing-page',
  partnersIntakeForm: '/partners/:agent_id/intake-form',
  schools: '/schools',
  programs: '/schools/:school_id/programs/:id',
  school: '/schools/:school_name',
  application: '/applications/:application_id',
  applicationList: '/applications',
  importantUpdates: '/important_updates',
  settings: '/settings',
  payment: '/payments/:id',
  orderReceipt: '/orders/:uuid/receipt',
  orderPay: '/orders/:id/pay',
  flywire: '/flywire/:id',
  discoveryBoard: '/discoveryboard',
  unauthorized: '/unauthorized',
  visaCalculator: '/visa-calculator',
  growthHub: '/growth-hub',
  agent: '/agents/:agent_id',
  agentDot: '/agent.:id',
  agentPayments: '/agents/:agent_id/payments',
  agentSign: '/agent_informations/:id/agent_sign',
  agents: '/agents'
};
export var PAGE_TAG_MAPPING = [{
  regex: /\/profile#general_info/,
  tag: ZENDESK_TAG_URL.profileGeneralInfo,
  href: '/profile#general_info'
}, {
  regex: /\/profile#education_history/,
  tag: ZENDESK_TAG_URL.profileEducationHistory,
  href: '/profile#education_history'
}, {
  regex: /\/profile#test_scores/,
  tag: ZENDESK_TAG_URL.profileTestScores,
  href: '/profile#test_scores'
}, {
  regex: /\/profile#visa_and_study_permit/,
  tag: ZENDESK_TAG_URL.profileVisaAndStudyPermit,
  href: '/profile#visa_and_study_permit'
}, {
  regex: /\/profile/,
  tag: ZENDESK_TAG_URL.profile,
  href: '/profile'
}, {
  regex: /\/students\/([\w-]+)#EducationHistoryPage/,
  tag: ZENDESK_TAG_URL.profileEducationHistoryRp,
  href: '/students/123#EducationHistoryPage',
  getTagIds: function getTagIds(regexMatch) {
    return ["studentId:".concat(regexMatch[1])];
  }
}, {
  regex: /\/students\/([\w-]+)#TestScoresPage/,
  tag: ZENDESK_TAG_URL.profileTestScoresRp,
  href: '/students/123#TestScoresPage',
  getTagIds: function getTagIds(regexMatch) {
    return ["studentId:".concat(regexMatch[1])];
  }
}, {
  regex: /\/students\/([\w-]+)#BackgroundInformationPage/,
  tag: ZENDESK_TAG_URL.profileBackgroundInformationRp,
  href: '/students/123#BackgroundInformationPage',
  getTagIds: function getTagIds(regexMatch) {
    return ["studentId:".concat(regexMatch[1])];
  }
}, {
  regex: /\/students\/([\w-]+)#UploadProfileDocumentsPage/,
  tag: ZENDESK_TAG_URL.profileUploadDocumentsRp,
  href: '/students/123#UploadProfileDocumentsPage',
  getTagIds: function getTagIds(regexMatch) {
    return ["studentId:".concat(regexMatch[1])];
  }
}, {
  regex: /\/students\/([\w-]+)$/,
  tag: ZENDESK_TAG_URL.profileStudentsRp,
  href: '/students/123',
  getTagIds: function getTagIds(regexMatch) {
    return ["studentId:".concat(regexMatch[1])];
  }
}, {
  regex: /\/students\/([\w-]+)\/dashboard/,
  tag: ZENDESK_TAG_URL.studentDashboard,
  href: '/students/123/dashboard',
  getTagIds: function getTagIds(regexMatch) {
    return ["studentId:".concat(regexMatch[1])];
  }
}, {
  regex: /\/students$/,
  tag: ZENDESK_TAG_URL.students,
  href: '/students'
}, {
  regex: /\/students\/([\w-]+)\/applications/,
  tag: ZENDESK_TAG_URL.applications,
  href: '/students/123/applications',
  getTagIds: function getTagIds(regexMatch) {
    return ["studentId:".concat(regexMatch[1])];
  }
}, {
  regex: /\/students\/([\w-]+)\/payments/,
  tag: ZENDESK_TAG_URL.payments,
  href: '/students/123/payments',
  getTagIds: function getTagIds(regexMatch) {
    return ["studentId:".concat(regexMatch[1])];
  }
}, {
  regex: /\/my_applications$/,
  tag: ZENDESK_TAG_URL.myApplications,
  href: '/my_applications'
}, {
  regex: /\/partners$/,
  tag: ZENDESK_TAG_URL.partners,
  href: '/partners'
}, {
  regex: /\/partners\/([\w-]+)\/landing-page/,
  tag: ZENDESK_TAG_URL.partnerLandingPage,
  href: '/partners/123/landing-page',
  getTagIds: function getTagIds(regexMatch) {
    return ["agentId:".concat(regexMatch[1])];
  }
}, {
  regex: /\/partners\/([\w-]+)\/intake-form/,
  tag: ZENDESK_TAG_URL.partnersIntakeForm,
  href: '/partners/123/intake-form',
  getTagIds: function getTagIds(regexMatch) {
    return ["agentId:".concat(regexMatch[1])];
  }
}, {
  regex: /\/schools$/,
  tag: ZENDESK_TAG_URL.schools,
  href: '/schools'
}, {
  regex: /\/schools\/([\w-]+)\/programs\/([\w-]+)/,
  tag: ZENDESK_TAG_URL.programs,
  href: '/schools/123/programs/456',
  getTagIds: function getTagIds(regexMatch) {
    return ["schoolId:".concat(regexMatch[1]), "programId:".concat(regexMatch[2])];
  }
}, {
  regex: /\/schools\/([\w-]+)/,
  tag: ZENDESK_TAG_URL.school,
  href: '/schools/university-of-california-berkeley-extension',
  getTagIds: function getTagIds(regexMatch) {
    return ["schoolId:".concat(regexMatch[1])];
  }
}, {
  regex: /\/applications\/([\w-]+)/,
  tag: ZENDESK_TAG_URL.application,
  href: '/applications/123',
  getTagIds: function getTagIds(regexMatch) {
    return ["app:".concat(regexMatch[1])];
  }
}, {
  regex: /\/applications$/,
  tag: ZENDESK_TAG_URL.applicationList,
  href: '/applications'
}, {
  regex: /\/important_updates$/,
  tag: ZENDESK_TAG_URL.importantUpdates,
  href: '/important_updates'
}, {
  regex: /\/settings$/,
  tag: ZENDESK_TAG_URL.settings,
  href: '/settings'
}, {
  regex: /\/payments\/([\w-]+)/,
  tag: ZENDESK_TAG_URL.payment,
  href: '/payments/123',
  getTagIds: function getTagIds(regexMatch) {
    return ["paymentId:".concat(regexMatch[1])];
  }
}, {
  regex: /\/orders\/([\w-]+)\/receipt$/,
  tag: ZENDESK_TAG_URL.orderReceipt,
  href: '/orders/12345678-09e8-449b-a7a5-3df69f64c7a4/receipt',
  getTagIds: function getTagIds(regexMatch) {
    return ["orderId:".concat(regexMatch[1])];
  }
}, {
  regex: /\/orders\/([\w-]+)\/pay$/,
  tag: ZENDESK_TAG_URL.orderPay,
  href: '/orders/123/pay',
  getTagIds: function getTagIds(regexMatch) {
    return ["orderId:".concat(regexMatch[1])];
  }
}, {
  regex: /\/flywire\/([\w-]+)/,
  tag: ZENDESK_TAG_URL.flywire,
  href: '/flywire/123',
  getTagIds: function getTagIds(regexMatch) {
    return ["flywireId:".concat(regexMatch[1])];
  }
}, {
  regex: /\/discoveryboard$/,
  tag: ZENDESK_TAG_URL.discoveryBoard,
  href: '/discoveryboard'
}, {
  regex: /\/unauthorized$/,
  tag: ZENDESK_TAG_URL.unauthorized,
  href: '/unauthorized'
}, {
  regex: /\/visa-calculator$/,
  tag: ZENDESK_TAG_URL.visaCalculator,
  href: '/visa-calculator'
}, {
  regex: /\/growth-hub$/,
  tag: ZENDESK_TAG_URL.growthHub,
  href: '/growth-hub'
}, {
  regex: /\/agents\/([\w-]+)$/,
  tag: ZENDESK_TAG_URL.agent,
  href: '/agents/123',
  getTagIds: function getTagIds(regexMatch) {
    return ["agentId:".concat(regexMatch[1])];
  }
}, {
  regex: /\/agent\.([\w-]+)$/,
  tag: ZENDESK_TAG_URL.agentDot,
  href: '/agent.123',
  getTagIds: function getTagIds(regexMatch) {
    return ["agentId:".concat(regexMatch[1])];
  }
}, {
  regex: /\/agents\/([\w-]+)\/payments$/,
  tag: ZENDESK_TAG_URL.agentPayments,
  href: '/agents/123/payments',
  getTagIds: function getTagIds(regexMatch) {
    return ["agentId:".concat(regexMatch[1])];
  }
}, {
  regex: /\/agent_informations\/([\w-]+)\/agent_sign/,
  tag: ZENDESK_TAG_URL.agentSign,
  href: '/agent_informations/123/agent_sign',
  getTagIds: function getTagIds(regexMatch) {
    return ["agentId:".concat(regexMatch[1])];
  }
}, {
  regex: /\/agents$/,
  tag: ZENDESK_TAG_URL.agents,
  href: '/agents'
}];